import styled from "styled-components"

export const Link = styled.span`
  color: ${props => props.theme.primaryHighlightColor};
  cursor: pointer;
`